// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"f68be187","359":"65bb4658","465":"f9d8b20a","791":"9d8acc76"}[chunkId] + ".chunk.js";
};